import styled from 'styled-components'
import * as Globals from '../../Globals'

export const Heading = styled(Globals.H2)`
  margin-bottom: 30px;
`;
